export const stepConfig = [
  {target: '.ManualImport', key: 'emailInvite'},
  {target: '.ImportSection', key: 'fileImport'},
];
